import { ActionKeys } from './constants';
import { ActionTypes } from './externals';

export function updateServerPlaybackPaused(callPlaybackPaused) {
  return {
    type: ActionKeys.UPDATE_SERVER_PLAYBACK_PAUSED,
    content: {
      callPlaybackPaused,
    },
  };
}

export function startValueExchange(param, currentStationId) {
  return {
    type: ActionKeys.START_VALUE_EXCHANGE,
    data: { param, currentStationId },
  };
}

export function playRewardsAd(params, rewardProperties) {
  return {
    type: ActionKeys.PLAY_REWARDS_AD,
    data: { ...params, rewardProperties },
  };
}

export function closeRewardsCoachmark({ reason }) {
  return {
    type: ActionKeys.CLOSE_REWARDS_COACHMARK,
    data: {
      reason,
    },
  };
}

export function addReplayTrackToPlaylist(sourceId, track, playlistIndex) {
  return {
    type: ActionKeys.ADD_REPLAY_TRACK_TO_PLAYLIST,
    data: { sourceId, track, playlistIndex },
  };
}

export function updateStation({ stationId, name, description, enableArtistMessages }) {
  return {
    type: ActionKeys.UPDATE_STATION,
    data: { stationId, name, description, enableArtistMessages },
  };
}

// Moves the playback state one song forward in the playlist
export function advancePlaylist(stationId) {
  return {
    type: ActionKeys.ADVANCE_PLAYLIST,
    data: {
      playlist: stationId,
    },
  };
}

export function startNextNonShuffleStation() {
  return {
    type: ActionKeys.START_NEXT_NON_SHUFFLE_STATION,
  };
}

export function promptStreamViolation(data) {
  return {
    type: ActionKeys.PROMPT_STREAM_VIOLATION,
    data,
  };
}

export function insertNewSimStreamViolation(data) {
  return {
    type: ActionKeys.INSERT_NEW_SIM_STREAM_VIOLATION,
    data,
  };
}

export function setCurrentTrackInPlaylist(playlistId, track) {
  return {
    type: ActionKeys.SET_CURRENT_TRACK_IN_PLAYLIST,
    data: {
      id: playlistId,
      track,
    },
  };
}

export function stationSetPlaylist(data) {
  return {
    type: ActionKeys.STATION_SET_PLAYLIST,
    data,
  };
}

export function playTrackFromStation(data) {
  return {
    type: ActionKeys.PLAY_TRACK_FROM_STATION,
    data,
  };
}

export function checkIsPlayableSource({ id, index, sortOrder, alertUserIfUnavailable = true }) {
  return {
    type: ActionKeys.CHECK_IS_PLAYABLE_SOURCE,
    data: {
      id,
      index,
      sortOrder,
      alertUserIfUnavailable,
    },
  };
}

export function stationTrackWillResumeFromSource(data) {
  return {
    type: ActionKeys.STATION_TRACK_RESUMED_FROM_SOURCE,
    data,
  };
}

export function initializePlayback(routeParams) {
  return {
    type: ActionKeys.START_INITIAL_PLAYBACK,
    data: routeParams,
  };
}

export function handleArtistAudioMessageCTA(ctaLink) {
  return {
    type: ActionKeys.HANDLE_ARTIST_AUDIO_MESSAGE_CTA,
    data: ctaLink,
  };
}

export function resetPlaybackStarted() {
  return {
    type: ActionKeys.RESET_PLAYBACK_STARTED,
  };
}

export function loadStationRecommendations() {
  return {
    type: ActionKeys.LOAD_STATION_RECOMMENDATIONS,
  };
}

export function setOrCreateStationFinished({ stationId, newStation = false, data, startupModeId }) {
  return {
    type: ActionTypes.SET_OR_CREATE_STATION_FINISHED,
    data: {
      ...data,
      stationId,
      newStation,
      startupModeId,
    },
  };
}

export function setAutoStartEnabled(shouldEnable) {
  return {
    type: ActionKeys.SET_AUTO_START_ENABLED,
    data: {
      shouldEnable,
    },
  };
}
